import React from "react";

import type { ButtonProps } from "@/components/ui/button";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  startIcon?: React.ReactNode;
  insideLabel?: React.ReactNode;
  endIcon?: React.ReactNode;
  isCurrency?: boolean;
  isPercentage?: boolean;
  button?: ButtonProps;
  errors?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      startIcon,
      insideLabel,
      endIcon,
      button,
      errors = false,
      isCurrency = false,
      isPercentage = false,
      ...props
    },
    ref
  ) => {
    return (
      <div className="relative flex w-full items-center">
        {startIcon}
        <input
          type={type}
          className={cn(
            "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-grey-50",
            errors && "border-destructive",
            (isCurrency || isPercentage) && "pr-2",
            type === "file" && "cursor-pointer",
            className
          )}
          ref={ref}
          {...props}
        />
        {insideLabel}
        {isCurrency && (
          <span className="absolute right-3 top-0 bottom-0 flex items-center justify-center text-sm">
            €
          </span>
        )}
        {isPercentage && (
          <span className="absolute right-3 top-0 bottom-0 flex items-center justify-center text-sm">
            %
          </span>
        )}
        {endIcon}
        {button && <Button {...button} />}
      </div>
    );
  }
);

export { Input };
